import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { loginStoreActions, RootStoreState, vaultStoreActions } from '@app/root-store';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as selectors from '../../../../root-store/vault-store/vault.selector';
import { UserService } from '@app/shared/services';
import * as vaultActions from '../../../../root-store/vault-store/actions';
import { AddConnectionComponent } from '../../add-connection-component/add-connection.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedConfirmationDialogComponent } from '../../shared-confirmation-dialog/shared-confirmation-dialog.component';
import { take } from 'rxjs/operators';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'my-responsibilities',
  templateUrl: './my-responsibilities.component.html',
  styleUrl: './my-responsibilities.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyResponsibilitiesComponent implements OnInit, OnDestroy {
  @Output() addUserDetails = new EventEmitter();
  @Output() createUserDetails = new EventEmitter();
  @Output() deleteUserDetails = new EventEmitter();
  @Input() currentUser;
  @Input() filteredUserVaults;
  @Input() filteredSuggestedVaults;
  private userService = inject(UserService);
  stateObject;
  subscription: Subscription = new Subscription();
  selectedUsers: any[] = [];
  vaultItems: any[];
  guardianList: any;
  loginId;
  vaultmemberItems;
  constructor(private sharedVaultService: SharedVaultService, private cd: ChangeDetectorRef, private store: Store, private _dialog: MatDialog) {}

  ngOnInit(): void {
    this.loginId = this.currentUser.id;
    this.subscription.add(
      this.store.pipe(select(selectors.getVaultOnboardItems('Last Updated'))).subscribe((item) => {
        this.vaultItems = [item];
        this.cd.detectChanges();
      })
    );
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  addUser(user) {
    this.subscription.add(
      this.sharedVaultService.createPersonalVaultMember({ user_id: user.user_id }).subscribe((data) => {
        if (data) {
          this.store.dispatch(new vaultStoreActions.GetVaultRequestAction(this.loginId, true));
          this.addUserDetails.emit(user.user_id);
        }
      })
    );
  }

  createNewUser() {
    const modalRef3 = this._dialog.open(AddConnectionComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'full-window-dialog-2',
      data: { fromAddVault: true, fromSharing: true, filterList: [] },
    });
    this.subscription.add(
      modalRef3.afterClosed().subscribe(
        (res) => {
          if (res) {
            const itemData = {
              ...res,
              ...(!res.user_id && { user_id: res.id }),
              ...(!res?.connection_status && { connection_status: 'invited' }),
            };
            this.createUserDetails.emit(itemData);
          }
        },
        (error) => {}
      )
    );
  }

  deleteMember(user) {
    this.subscription.add(
      this.sharedVaultService.getVaults(this.currentUser.id).subscribe(async (vaults) => {
        this.vaultmemberItems = vaults.filter((vault) => vault.type?.toLowerCase() === 'personal' && vault.is_system === true);
      })
    );
    const loginId = this.currentUser.id;
    const sharedDialogRef = this._dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        materialIcon: 'delete',
        text: `Are you sure you want to delete this member ?`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        function filterMatchingUsers(vaults: any[]) {
          for (const vault of vaults) {
            if (vault.user_id === user.user_id) {
              if (vault.vaultMembers && Array.isArray(vault.vaultMembers)) {
                const matchingMember = vault.vaultMembers.find((member) => {
                  return member.user_id === loginId; // strict equality
                });
                if (matchingMember) {
                  return matchingMember; // Return the id of the first match
                }
              }
            }
          }
          return null; // Return null if no match is found
        }
        const Vaultmembers = filterMatchingUsers(this.vaultmemberItems);
        let model = {
          id: Vaultmembers.id,
          user_id: Vaultmembers.user_id ? Vaultmembers.user_id : Vaultmembers.memberUser.id,
        };
        this.subscription.add(
          this.sharedVaultService.deleteVaultMember(model.user_id, model.id).subscribe((data) => {
            if (data) {
              this.store.dispatch(new vaultStoreActions.GetVaultRequestAction(this.loginId, true));
              this.deleteUserDetails.emit(user.user_id);
              // this.trackEventsInMixPanel('remove');
              this.cd.markForCheck();
            }
          })
        );
      })
    );
  }
}
